import React, { ReactNode, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { isGlobalSideNavCollapsed } from '../../Utils/isGlobalSideNavCollapsed'
import SubMenuArrowDown from '../Icons/SubMenuArrowDown'
import styles from './SubMenu.module.scss'

type SubMenuProps = {
  icon?: React.ReactNode
  title: string
  theme?: 'light' | 'dark'
  defaultOpen?: boolean
  selected?: boolean
  onOpen?: () => unknown
  activeKey?: string
  submenuKey?: string
  children?: ReactNode
}

const SubMenu: React.FC<SubMenuProps> = ({
  defaultOpen = false,
  icon,
  title,
  theme = 'light',
  selected,
  children = null,
  onOpen = () => {},
  activeKey,
  submenuKey,
  ...props
}) => {
  const [open, setopen] = useState(defaultOpen)
  const [menuActive, setMenuActive] = useState(selected)
  const location = useLocation()

  const handleSetOpen = () => {
    setopen((prev) => {
      if (!prev) {
        onOpen()
      }
      return !prev
    })
  }

  useEffect(() => {
    if (children) {
      let anyOneSelected = false
      ;(children as any[]).forEach((child) => {
        if (location.pathname.includes(child?.props?.to || child?.props?.children?.props?.to)) {
          anyOneSelected = true
        }
      })
      setMenuActive(anyOneSelected)
      setopen(anyOneSelected)
    }
  }, [children])

  const collapsed = isGlobalSideNavCollapsed()

  return (
    <div
      className={[styles['sub-menu'], theme === 'dark' ? styles['sub-menu__dark'] : ''].join(' ')}
      data-open={!collapsed && open ? 'true' : 'false'}
      data-selected={menuActive ? 'true' : 'false'}
      data-xcollapsed={collapsed}
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        className={[
          styles['sub-menu__title'],
          theme === 'dark' ? styles['sub-menu__title__dark'] : '',
        ].join(' ')}
        style={{
          lineHeight: '40px',
        }}
        data-selected={menuActive ? 'true' : 'false'}
        data-open={!collapsed && open ? 'true' : 'false'}
        data-xcollapsed={collapsed}
        onClick={handleSetOpen}
      >
        {icon ? <span>{icon}</span> : null}
        {!collapsed ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'middle',
              marginLeft: '10px',
              flexGrow: 1,
            }}
          >
            <div>{title}</div>
            <div>
              <SubMenuArrowDown
                className={[
                  theme === 'dark' ? styles['sub-menu__arrow-icon__dark'] : '',
                  styles['sub-menu__arrow-icon'],
                ].join(' ')}
                data-collapse={open ? 'true' : 'false'}
                data-selected={menuActive ? 'true' : 'false'}
              />
            </div>
          </div>
        ) : null}
      </div>
      <div
        className={[
          styles['sub-menu__dropdown'],
          [styles['sub-menu'], theme === 'dark' ? styles['sub-menu__dark'] : ''].join(' '),
        ].join(' ')}
        style={{
          width: '100%',
        }}
        data-open={!collapsed && open ? 'true' : 'false'}
      >
        <ul>{children}</ul>
      </div>
      <div
        className={[styles['sub-menu__hoverable-dropdown']].join(' ')}
        data-open={!collapsed && open ? 'true' : 'false'}
      >
        <ul>{children}</ul>
      </div>
    </div>
  )
}

export default SubMenu
